// Vite only transpiles syntax: core-js supplies the newer built-ins
import 'react-app-polyfill/stable';
import './replaceAllPolyfill';
import './agGridSetup';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reloadOnStaleChunk from './reloadOnStaleChunk';
import * as serviceWorker from './serviceWorker';
import UnsupportedBrowser from './UnsupportedBrowser';

const isIE = /*@cc_on!@*/ false || !!document.documentMode;

reloadOnStaleChunk();

const root = createRoot(document.getElementById('root'));
if (isIE) {
  root.render(<UnsupportedBrowser />);
} else {
  root.render(<App />);
}

// Removes any service worker an old (CRA) build registered
serviceWorker.unregister();
